import types from './types';

const manualRehydrateMap = (map) => ({
  type: types.REHYDRATE,
  payload: {
    map
  }
});

const setExtent = (extent) => ({
  type: types.SET_EXTENT,
  payload: {
    extent
  }
});

const mapLoaded = () => ({
  type: types.MAP_LOADED,
  payload: {}
});

const setAddIrwinIdToPerimeter = (perimeterIncident) => ({
  type: types.IRWIN_ID_PERIMETER,
  payload: {
    perimeterIncident
  }
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  manualRehydrateMap,
  setExtent,
  mapLoaded,
  setAddIrwinIdToPerimeter
};
